module.exports = __webpack_public_path__ + "static/img/soldout.5d4f40e9.png";